module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_concept_03-05aeb5ea049c3cdca9ed7277c39314a5.jpg";